module.exports = __webpack_public_path__ + "img/5.95f0e2cd.png";